// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-management[data-v-1042c516]{padding:30px 30px 0 30px}[data-v-1042c516] .el-tabs__content{height:calc(100vh - 200px);overflow-y:auto}", ""]);
// Exports
module.exports = exports;
